"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authDiscountContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authDiscountContract = c.router({
    getSubscriberPartnerDiscountCode: {
        method: 'GET',
        path: '/get-subscriber-partner-discount-code/:partner_code',
        responses: {
            200: zod_1.z.object({
                accessGranted: zod_1.z.boolean(),
                codeInfo: models_1.ZDiscountCodeInfo.optional(),
            }),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=discount.auth.contract.js.map